<p-panel #primePanel class="collapsible-panel" [toggleable]="true">
  <p-header class="collapsible-panel__header">
    <ng-content select="header"></ng-content>
  </p-header>
  <ng-content></ng-content>
</p-panel>
